export default "__VITE_ASSET__HS7QaVEK__";